import { render, staticRenderFns } from "./SignageCalendars.vue?vue&type=template&id=0dc43ade&"
import script from "./SignageCalendars.vue?vue&type=script&lang=js&"
export * from "./SignageCalendars.vue?vue&type=script&lang=js&"
import style0 from "./SignageCalendars.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports